// extracted by mini-css-extract-plugin
export default {"cardList":"list_cardList__83Kpq","card":"list_card__EKAD1"};